import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const BreadCrumbOne = ({ title, page }) => {
  return (
    <div className="breadcrum-area">
      <div className="container">
        <div className="breadcrumb">
          <ul className="list-unstyled">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Blog</li>
          </ul>
          <h1
            className="title h2"
            dangerouslySetInnerHTML={{ __html: title }}
          ></h1>
        </div>
      </div>
      <ul className="shape-group-8 list-unstyled">
        <li className="shape shape-1">
          <StaticImage
            src="../../images/others/bubble-9.png"
            loading="eager"
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="cerchio"
          />
        </li>
        <li className="shape shape-2">
          <StaticImage
            src="../../images/others/bubble-11.png"
            loading="eager"
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="cerchio"
          />
        </li>
        <li className="shape shape-3">
          <StaticImage
            src="../../images/others/line-4.png"
            loading="eager"
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="linea"
          />
        </li>
      </ul>
    </div>
  )
}

export default BreadCrumbOne
